import React from "react";
import { Link } from "react-router-dom";
import { t } from "../../lib/i18n";

const COL = ({ title, children, testid }) => (
  <div data-testid={testid}>
    <p className="mb-4 text-xs uppercase tracking-[0.28em] text-[#1A1A1A]/50">
      {title}
    </p>
    <ul className="space-y-2 text-sm text-[#1A1A1A]/80">{children}</ul>
  </div>
);

const Item = ({ to, children, testid }) => (
  <li>
    <Link
      to={to}
      data-testid={testid}
      className="transition hover:text-[#C8A24B]"
    >
      {children}
    </Link>
  </li>
);

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#EAE3D2] bg-[#FAF7F2]"
    >
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-6 sm:py-20">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          <COL title={t("footer.col.services")} testid="footer-col-services">
            <Item to="/services" testid="footer-link-all-services">
              All services
            </Item>
            <Item to="/services/wedding-photography" testid="footer-link-wedding">
              Weddings
            </Item>
            <Item to="/services/family-portraiture" testid="footer-link-family">
              Family & portraits
            </Item>
            <Item to="/services/events-celebrations" testid="footer-link-events">
              Events
            </Item>
          </COL>
          <COL title={t("footer.col.help")} testid="footer-col-help">
            <Item to="/faqs" testid="footer-link-faqs">FAQs</Item>
            <Item to="/help" testid="footer-link-help">Help center</Item>
            <Item to="/plan" testid="footer-link-plan">Plan a shoot</Item>
          </COL>
          <COL title={t("footer.col.legal")} testid="footer-col-legal">
            <Item to="/policies/terms" testid="footer-link-terms">{t("footer.legal.terms")}</Item>
            <Item to="/policies/privacy" testid="footer-link-privacy">{t("footer.legal.privacy")}</Item>
            <Item to="/policies/refund" testid="footer-link-refund">{t("footer.legal.refund")}</Item>
            <Item to="/policies/about" testid="footer-link-about">{t("footer.legal.about")}</Item>
          </COL>
          <COL title={t("footer.col.contact")} testid="footer-col-contact">
            <li className="text-sm text-[#1A1A1A]/80">{t("help.contact.email")}</li>
            <li className="text-sm text-[#1A1A1A]/80">{t("help.contact.phone")}</li>
          </COL>
        </div>

        <div className="mt-14 flex items-baseline justify-between border-t border-[#EAE3D2] pt-8">
          <p className="font-display text-base tracking-[0.06em] text-[#1A1A1A]">
            Shutter<span className="text-[#C8A24B]">KART</span>
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#1A1A1A]/50 sm:text-xs">
            {t("footer.copy")}
          </p>
        </div>
      </div>
    </footer>
  );
}
